import * as React from "react";
const SvgFiRrCursorTextAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-cursor-text-alt_svg__a)">
      <path
        fill="#062147"
        d="M22 17.351V6.65A3.492 3.492 0 1 0 17.351 2H6.65A3.492 3.492 0 1 0 2 6.65v10.7A3.492 3.492 0 1 0 6.65 22h10.7A3.492 3.492 0 1 0 22 17.351m-4.949 2.65H6.95A3.485 3.485 0 0 0 4 17.05V6.95A3.485 3.485 0 0 0 6.95 4h10.1A3.485 3.485 0 0 0 20 6.95v10.1A3.48 3.48 0 0 0 17.051 20m3.45-18a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m-17 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 20a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m17 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M13 9v3h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 0 1 1 1 1 0 0 1 0 2 2.98 2.98 0 0 1-2-.78 2.98 2.98 0 0 1-2 .78 1 1 0 1 1 0-2 1 1 0 0 0 1-1v-1h-1a1 1 0 0 1 0-2h1V9a1 1 0 0 0-1-1 1 1 0 0 1 0-2c.74.002 1.453.28 2 .78.546-.5 1.259-.778 2-.78a1 1 0 1 1 0 2 1 1 0 0 0-1 1"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-cursor-text-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCursorTextAlt;
